<script>
import Endpoints from "../../components/common/Endpoints";
import Common from "../../components/common/Common";
import Request from "../../components/common/Request";
import { mapActions } from "vuex";

export default {
  init: async (payload) => {
    let response = (
      await Request.do(
        payload,
        "GET",
        Request.getDefaultHeader(payload),
        {},
        `${Endpoints.systemUsers.getMe}`
      )
    ).data;
    payload.user = response.result;
    payload.filterWaitingForResponse();
    setInterval(() => payload.filterWaitingForResponse(), 30000);
  },
  methods: {
    filterWaitingForResponse: async function () {
      let beginDate = new Date();
      beginDate.setDate(beginDate.getDate() - 30);

      let filters = {
        statusOrder: "WAITING_FOR_RESPONSE",
        beginDate,
        endDate: Date(),
      };
      let headers = Request.getDefaultHeader(this);

      Request.do(
        this,
        "POST",
        headers,
        filters,
        `${Endpoints.orders.holder.listOrdersByStatus}`,
        (response) => {
          this.items = response.results;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    load() {
      if (this.optionsTab == "PARTS") this.optionsTab = "SERVICES";
      else if (this.optionsTab == "SERVICES") this.optionsTab = "CERTIFIES";
      else if (this.optionsTab == "CERTIFIES") this.optionsTab = "PARTS";
    },
    addCompany: function (item) {
      this.optionsTab = item.typeOrder;
      this.order = item;
      console.log("TAB SELECTED", item.typeOrder, this.order);
      setTimeout(() => {
        switch (this.optionsTab) {
          case "PARTS":
            $("#modalAddCompanyPart").modal("show");
            break;
          case "SERVICES":
            $("#modalAddCompanyService").modal("show");
            break;
          default:
            $("#modalAddCompanyCertifie").modal("show");
        }
      }, 250);
    },
    selectItem: async function (item) {
      this.order = item;
      this.optionsTab = item.typeOrder;

      if (item.isSearchByCompany && item.trucker && item.trucker._id) {
        await this.getTrucksByUser(item.trucker._id);
      } else {
      }

      switch (this.optionsTab) {
        case "PARTS":
          $("#modalOrderPart").modal("show");
          break;
        case "SERVICES":
          $("#modalOrderService").modal("show");
          break;
        default:
          $("#modalOrderCertified").modal("show");
      }
    },
    confirmArchive: function (item) {
      this.confirmationData = {
        orderSelected: item,
      };

      this.optionsTab = item.typeOrder;
      setTimeout(() => {
        switch (this.optionsTab) {
          case "PARTS":
            $("#confirmationCloseHolderPart").modal("show");
            break;
          case "SERVICES":
            $("#confirmationCloseHolderService").modal("show");
            break;
          default:
            $("#confirmationCloseHolderCertifie").modal("show");
        }
      }, 100);
    },
    showMesage: function (result) {
      if (result == 1) {
        $("#modalAddCompanyPart").modal("toggle");
        this.flashMessage.success(
          this.configMessage(
            this.$t("string.msg.addCompany.register.title.success"),
            this.$t("string.msg.addCompany.register.message.success"),
            3000
          ),
          {
            mounted: this.showText(
              this.$t("string.msg.addCompany.register.message.success")
            ),
            destroyed: this.clearText(),
          }
        );
      } else if (result == 2) {
        $("#modalAddCompanyPart").modal("toggle");
        this.flashMessage.error(
          this.configMessage(
            this.$t("string.msg.addCompany.register.title.error"),
            this.$t("string.msg.addCompany.register.message.error"),
            3000
          ),
          {
            mounted: this.showText(
              this.$t("string.msg.addCompany.register.message.error")
            ),
            destroyed: this.clearText(),
          }
        );
      }
    },
    camelize: Common.camelize,
    toUpperCase: Common.toUpperCase,
  },
};
</script>
